// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObject = (value: any): value is object =>
    // eslint-disable-next-line
    value && typeof value === 'object' && value.constructor === Object;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isFilledObject = (value: any): value is object =>
    isObject(value) && Object.keys(value).length > 0;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isString = (value: any): value is string =>
    typeof value === 'string' || value instanceof String;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isFilledString = (value: any): value is string => isString(value) && value.length > 0;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEmptyString = (value: any): value is string => isString(value) && value.length === 0;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNotEmptyString = (value: any): value is string => isFilledString(value);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNumber = (value: any): value is number =>
    typeof value === 'number' && Number.isFinite(value);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNumeric = (value: any): value is number | string =>
    isNumber(value) || (isFilledString(value) && isNumber(Number(value)));

// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-function-type
export const isFunction = (value: any): value is Function => typeof value === 'function';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArray = (value: any): value is Array<any> =>
    typeof value === 'object' && Array.isArray(value);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isFilledArray = (value: any): value is Array<any> =>
    isArray(value) && value.length > 0;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isUndefined = (value: any): value is undefined => typeof value === 'undefined';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isBoolean = (value: any): value is boolean => value === true || value === false;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNaturalNumber = (value: any): value is number => {
    if (!isNumeric(value)) {
        return false;
    }

    const number = Number(value);

    return Number.isInteger(number) && number > 0;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEmpty = (value: any) =>
    // eslint-disable-next-line
    [undefined, null, false].includes(value) || value.toString().length === 0;

export const isNotEmpty = (value: unknown) => !isEmpty(value);

export const isEnumValue = <T extends Record<string, string | number>>(
    someEnum: T,
    value: unknown
): value is T => Object.entries(someEnum).some(([, val]) => val === value);

export const isEnumValueNoNumericKeys = <T extends Record<string, string | number>>(
    someEnum: T,
    value: unknown
): value is T =>
        Object.entries(someEnum).some(([key, val]) => val === value && Number.isNaN(Number(key)));
